// When changing card template image, just change ID of image (https://images.unsplash.com/{IMAGE-ID}?q=80&w=600&h=800)

import { CARD_DESIGN } from "../../../settings/features/cards/defaults";

export const CARDS_TEMPLATES = [
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "emoji-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Tune in!",
      text: "What's your go-to work jam? Drop your song suggestions!",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Office Vibes Playlist",
      text: "What's your go-to work jam? Drop your song suggestions!",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label", "arrow"],
      design: "emoji-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "The big picture",
      text: "Our mission and impact, guiding us every day.",
      linkText: "Read more",
      label: "Company vision",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "atlassian-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Our north star",
      text: "Why we do what we do - our mission at a glance.",
      linkText: "Read more",
      label: "Company purpose",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-16.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-16.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label", "arrow"],
      design: "emoji-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Report a bug",
      text: "Make sure your bug reports are clear and actionable.",
      linkText: "Read more",
      label: "Development",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: "bootstrap/Bug",
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "text", "label", "arrow"],
      design: "atlassian-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Report a bug",
      text: "Make sure your bug reports are clear and actionable.",
      linkText: "Read more",
      label: "Development",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-20.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-20.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "linkText"],
      design: "image-seven",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Product demo kit",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Read more",
      label: "Sales & Marketing",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1617785899222-fe06b15b6dd5?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1617785899222-fe06b15b6dd5?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "image-eight",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Atlassian Team '24",
      text: "Getting ready for the event",
      linkText: "Read more",
      label: "Sales & Marketing",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: "atlaskit/CalendarIcon",
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1508674861872-a51e06c50c9b?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1508674861872-a51e06c50c9b?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      imageSecond: {
        imageUrl:
          "https://images.unsplash.com/photo-1507878866276-a947ef722fee?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1507878866276-a947ef722fee?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text"],
      design: "emoji-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Travel smart",
      text: "Your guide to company travel policies.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "palm_tree",
        name: "Palm Tree",
        short_names: ["palm_tree"],
        colons: ":palm_tree:",
        emoticons: [],
        unified: "1f334",
        skin: null,
        native: "🌴",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "atlassian-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Reimbursment guide",
      text: "How to claim expenses hassle-free.",
      linkText: "Read more",
      label: "Company purpose",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-3.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-3.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-four",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Cybersecurity policy",
      text: "What's your go-to work jam? Drop your song suggestions!",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label", "arrow"],
      design: "emoji-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Security matters",
      text: "Best practices to protect company data.",
      linkText: "Read more",
      label: "Development",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: "bootstrap/ShieldCheck",
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1483412033650-1015ddeb83d1?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "text"],
      design: "image-five",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Launch like a pro",
      text: "Everything you need to run a successful campaign.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1741627872533-52df24885303?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1741627872533-52df24885303?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "emoji-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Start here!",
      text: "Your quick guide to getting started at our company",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "checkered_flag",
        name: "Chequered Flag",
        short_names: ["checkered_flag"],
        colons: ":checkered_flag:",
        emoticons: [],
        unified: "1f3c1",
        skin: null,
        native: "🏁",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Employee onboarding guide",
      text: "Everything you need to run a successful campaign.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1741882239311-e769227bdee5?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1741882239311-e769227bdee5?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "linkText"],
      design: "image-six",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Company Vision",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Read more",
      label: "Read more",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1600275669439-14e40452d20b?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1600275669439-14e40452d20b?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 256,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-three",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 14,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Demo Playbook",
      text: "Photography guidelines, crucial for all external comm.m.",
      label: "Marketing",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: { light: "#000", dark: "#FFF" },
        text: { light: "#FFF", dark: "#000" },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1706804285677-4eb783c82642?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1706804285677-4eb783c82642?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["text", "arrow", "linkText", "title"],
      design: "steps-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      text: "Discover new opportunities and uncover hidden potential. Dive deep into insights that inspire growth and innovation. Connect ideas, explore directions, and build a foundation for success. Every discovery moves the vision forward, shaping future steps and goals.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "steps",
      columns: 3,
      layout: ["text", "title"],
      design: "steps-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      text: "Begin the journey by exploring needs and possibilities. Understand challenges from every angle to create a strong foundation. Analyze, observe, and gather everything essential. Shape the path forward with curiosity, openness, and focus.",
      linkText: "Read more",
      label: "Read more",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon", "text"],
      design: "number-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "56+",
      text: "Projects completed successfully across diverse industries, driving innovation, growth, and measurable results.",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
  {
    height: 304,
    config: {
      type: "number",
      columns: 3,
      layout: ["icon", "text"],
      design: "number-two",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Discover",
      number: "100K",
      text: "Users achieved their goal",
      icon: "bootstrap/FillPeopleFill",
      colors: {
        accent: {
          light: "#1D7AFC",
          dark: "#1D7AFC",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
    },
  },
];

export const HIDDEN_CARDS_TEMPLATE_STYLES = [
  CARD_DESIGN.NUMBER_ONE,
  CARD_DESIGN.NUMBER_TWO,
  CARD_DESIGN.STEPS_ONE,
  CARD_DESIGN.STEPS_TWO,
];

export const OVERVIEW_CARDS_TEMPLATES = [
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "text"],
      design: "image-five",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Launch like a pro",
      text: "Everything you need to run a successful campaign.",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1741627872533-52df24885303?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1741627872533-52df24885303?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "emoji",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "emoji-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Tune in!",
      text: "What's your go-to work jam? Drop your song suggestions!",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        source: "csf",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-1.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "illustration",
      columns: 3,
      layout: ["title", "text", "label"],
      design: "atlassian-one",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Our north star",
      text: "Why we do what we do - our mission at a glance.",
      linkText: "Read more",
      label: "Company purpose",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "earth_africa",
        name: "Earth Globe Europe-Africa",
        short_names: ["earth_africa"],
        colons: ":earth_africa:",
        emoticons: [],
        unified: "1f30d",
        skin: null,
        native: "🌍",
      },
      image: {
        imageUrl:
          "https://caelor-apps.web.app/images/illustrations/illustration-16.svg",
        source: "unsplash",
        link: "https://caelor-apps.web.app/images/illustrations/illustration-16.svg",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "label", "linkText"],
      design: "image-seven",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Product demo kit",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Read more",
      label: "Sales & Marketing",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1617785899222-fe06b15b6dd5?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1617785899222-fe06b15b6dd5?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 290,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow"],
      design: "image-four",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Cybersecurity policy",
      text: "What's your go-to work jam? Drop your song suggestions!",
      linkText: "Read more",
      label: "Office Vibes",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "radio",
        name: "Radio",
        short_names: ["radio"],
        colons: ":radio:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "📻",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
  {
    height: 304,
    config: {
      type: "image",
      columns: 3,
      layout: ["title", "arrow", "linkText"],
      design: "image-six",
      textAlign: "left",
      height: 250,
      iconSize: 100,
      gap: 16,
      iconRadius: 50,
      borderRadius: 8,
      hasTabs: false,
    },
    card: {
      id: crypto.randomUUID(),
      tabId: "7ncyt6",
      title: "Company Vision",
      text: "Photography guidelines, crucial for all external comm.",
      linkText: "Read more",
      label: "Read more",
      button: "View more",
      quote:
        "Design is not just what it looks like and feels like. Design is how it works.",
      author: "Steve Jobs",
      colors: {
        accent: {
          light: "#E2483D",
          dark: "#F15B50",
        },
        text: {
          light: "#FFFFFF",
          dark: "#050505",
        },
      },
      icon: {
        id: "broccoli",
        name: "Broccoli",
        short_names: ["broccoli"],
        colons: ":broccoli:",
        emoticons: [],
        unified: "1f966",
        skin: null,
        native: "🥦",
      },
      image: {
        imageUrl:
          "https://images.unsplash.com/photo-1600275669439-14e40452d20b?q=80&w=600&h=800",
        source: "unsplash",
        link: "https://images.unsplash.com/photo-1600275669439-14e40452d20b?q=80&w=600&h=800",
        id: "OHqbSPQC1qs",
      },
      newTab: "true",
      link: {
        id: "",
        link: "",
        title: "",
        type: "",
        source: "",
      },
      overlay: {
        isActive: false,
        color: "#000",
        opacity: 0.3,
      },
    },
  },
];

export const getCardsTemplates = ({
  cornerRadius,
  selectedColors,
  isInOverview = false,
}) =>
  (isInOverview ? OVERVIEW_CARDS_TEMPLATES : CARDS_TEMPLATES)
    .sort(() => Math.random() - 0.5)
    .map((template) => ({
      ...template,
      config: {
        ...template.config,
        borderRadius: cornerRadius || 14,
      },
      card: {
        ...template.card,
        colors: {
          accent: {
            light:
              selectedColors?.light[0]?.accent ||
              template.card.colors.accent.light ||
              "#000",
            dark:
              selectedColors?.dark[0]?.accent ||
              template.card.colors.accent.dark ||
              "#FFF",
          },
          text: {
            light:
              selectedColors?.light[0]?.text ||
              template.card.colors.text.light ||
              "#FFF",
            dark:
              selectedColors?.dark[0]?.text ||
              template.card.colors.text.dark ||
              "#000",
          },
        },
      },
    }));
